import { Bell, X } from 'lucide-react';
import { useToasts, dismissToast } from '../../notifications/toastStore';

/**
 * Renders transient toasts pinned to the bottom of the task pane. Driven by the
 * module-scope toast store (fired by NotificationProvider on a live event).
 */
export function ToastHost(): JSX.Element | null {
  const toasts = useToasts();
  if (toasts.length === 0) return null;

  return (
    <div className="pointer-events-none absolute inset-x-0 bottom-0 z-50 flex flex-col gap-2 p-3">
      {toasts.map((t) => (
        <div
          key={t.id}
          className="pointer-events-auto flex items-start gap-2 rounded-lg border border-border bg-background p-3 shadow-lg"
          role={t.onClick ? 'button' : 'status'}
          tabIndex={t.onClick ? 0 : undefined}
          onClick={
            t.onClick
              ? () => {
                  t.onClick?.();
                  dismissToast(t.id);
                }
              : undefined
          }
        >
          <Bell className="mt-0.5 h-4 w-4 flex-shrink-0 text-primary" />
          <div className="min-w-0 flex-1">
            <p className="truncate text-sm font-medium text-foreground">{t.title}</p>
            {t.message && (
              <p className="mt-0.5 line-clamp-2 text-xs text-muted-foreground">{t.message}</p>
            )}
          </div>
          <button
            type="button"
            aria-label="Dismiss"
            className="flex-shrink-0 text-muted-foreground hover:text-foreground"
            onClick={(e) => {
              e.stopPropagation();
              dismissToast(t.id);
            }}
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      ))}
    </div>
  );
}
